<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <label>所属门店</label>
          <el-select v-model="shopId" placeholder="Select" class="select-item">
            <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <DatePickerRange title="入库时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item">
          <label>入库状态</label>
          <el-select v-model="state" placeholder="Select" class="select-item">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <!--          <label>记录搜索</label>-->
          <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <!--            <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>-->
        </div>
      </div>

      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <!--          <el-button type="success" @click="add">添加</el-button>-->
        </div>
<!--        <div class="dialog-input-btn">-->
<!--          <ElButtons type="success" icon="Plus"  @click="checkDetail(-1)"> 添加 </ElButtons>-->
<!--&lt;!&ndash;          <el-button type="success" @click="add">添加</el-button>&ndash;&gt;-->
<!--        </div>-->
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="shopName" label="所属门店"/>
      <el-table-column property="createTime" label="入库时间"/>
      <el-table-column property="numberNo" label="关联批次号"/>
      <el-table-column property="shipAddress" label="发货地址"/>
      <el-table-column property="trackingNumber" label="快递单号"/>
      <el-table-column property="freight" label="快递运费"/>
      <el-table-column property="" label="入库货单" class-name="cursor">
        <template #default="scope">
<!--          <el-image class="item-img" fit="cover" :src="scope.row.waybillSmallImg" @click="showImg(scope.row.waybillImg)">-->
<!--            <template #error>-->
<!--              <div class="el-img-error">暂无图片</div>-->
<!--            </template>-->
<!--          </el-image>-->
          <div v-if="scope.row.stockImgList.length > 0" class="cursor" @click="userImgList(scope.row)">
            <el-image class="item-img" fit="fill" :src="scope.row.stockImgList[0].img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>
          <div v-else>
            <el-image class="item-img" fit="fill"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column property="" label="状态" >
        <template #default="scope">
          {{scope.row.state == 1?'待入库': scope.row.state == 2?'已驳回':scope.row.state == 3?'部分入库':scope.row.state == 4?'已入库':''}}
        </template>
      </el-table-column>
      <el-table-column property="adminName" label="添加人" />
      <el-table-column property="" label="操作" >
        <template #default="scope">
          <el-button type="text" @click="putStorage(scope.$index, scope.row)">编辑</el-button>
          <el-button type="text" @click="delStorage(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import {getFormData, postFormData} from '@/api/api';
import {getPurchasePageList, listStockCommodity, updatePurchaseDel} from '@/api/url';
import Dialog from '@/assets/js/dialog'
import DatePickerRange from "@/components/DatePickerRange_30";
import SearchComponents from "@/components/SearchComponents";
import ConsumeDetailDialog from "@/views/user/components/ConsumeDetailDialog";
import ImgViewer from "@/assets/js/imageViewer";
import PutStorageDialog from "@/views/commodity/components/PutStorageDialog";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents},
  data() {
    return {
      // userForm: this.value.userForm,
      pageDataList: [],
      id: this.value.id,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待入库', value: 1},
        {label: '已驳回', value: 2},
        {label: '部分入库', value: 3},
        {label: '已入库', value: 4},
      ],
      state: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //搜索
      searchTypeList: [
        {label : '批次号', value : 1},
        {label : '添加人', value : 2},
      ],
      searchType: 1,
      searchValue: '',

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      // visibleShopList: JSON.parse(sessionStorage.getItem('visibleShopList')),
    }
  },
  methods: {

    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.stockImgList,
          id: row.id,
          width: 908,
          from: 5,
          hideBtn: true
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['shopId'] = this.shopId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getPurchasePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    checkDetail(idx, row) {
      let consumeForm = {}
      let consumeId = 0
      if(idx > -1) {
        consumeForm = Object.assign({}, row);
        consumeId = consumeForm.id
      }
      Dialog.open({
        title: '',
        component: ConsumeDetailDialog,
        data: {
          userForm: this.userForm,
          consumeId: consumeId,
          idx: idx
        },
        confirm: (result) => {
          this.getPage();
          this.getUserInfo()
          sessionStorage.setItem('recordState', JSON.stringify(true))
        }
      })
    },

    putStorage(idx, row) {
      getFormData(listStockCommodity, {id: row.id}).then(data => {
        if(data.code == 200) {
          let _title = '编辑入库记录';
          let purchaseList = data.data
          Dialog.open({
            title: _title,
            component: PutStorageDialog,
            data: {
              purchaseList: purchaseList,
              storageForm: row,
              ids: idx,
              shopId: row.shopId,
              width: '670px',
            },
            confirm: (result) => {
              this.getPage()
            }
          })
        }
      })
    },


    delStorage(idx, row) {
      this.$confirm('确认删除关联号为【' + row.numberNo + '】的入库记录吗？').then(() => {
        postFormData(updatePurchaseDel, {id: row.id}).then(data => {
          let {msg, code } = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getPage()
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        })
      })
    },

  },
  mounted() {
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    // this.getShopList()
    this.getPage();
    // this.getUserInfo()
  }
}
</script>

<style>
.item-img {
  width: 80px;
  height: 80px;
}

</style>
